export default __webpack_public_path__ + "static/media/error403.9ec01f4c.svg";